import React from "react";
import { Link } from "react-router-dom"; // Kept for potential internal links like privacy/terms if added later
import logo from "../assets/img/logo.png";

// You'll need to replace this placeholder with your actual logo path
// For example: import companyLogo from './assets/img/your-logo.png';

const Footer = () => {
  return (
    <>
      <style>
        {`
          .footer-light-theme {
            background-color: #ffffff;
            padding-top: 3rem;
            padding-bottom: 3rem;
            color: #333333; /* Dark grey for text */
            font-family: Arial, Helvetica, sans-serif; /* Basic font stack */
           /* Red top border as seen above the footer in image */
          }

          .footer-light-theme .footer-column {
            margin-bottom: 2rem; /* Spacing when columns stack on mobile */
          }

          .footer-light-theme .footer-column h3 {
            color: #D93A3A; /* Red color for headings */
            font-weight: bold;
            font-size: 0.9rem; /* Adjusted for a typical footer heading size */
            margin-bottom: 1.2rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .footer-light-theme .footer-column p,
          .footer-light-theme .footer-column .footer-list-item {
            font-size: 0.9rem; /* Standard text size */
            margin-bottom: 0.6rem; 
            line-height: 1.6;
          }
          
          .footer-light-theme .footer-column strong {
            font-weight: bold; /* Ensure strong tag is bold */
            color: #333333;
          }

          .footer-light-theme .footer-column a.footer-link,
          .footer-light-theme .footer-column a { /* General styling for links in footer */
            color: #333333;
            text-decoration: none;
            transition: color 0.2s ease;
          }

          .footer-light-theme .footer-column a.footer-link:hover,
          .footer-light-theme .footer-column a:hover {
            color: #A82C2C; /* Darker red on hover */
            text-decoration: underline;
          }
          
          /* Specific for links that should behave like block elements in a list */
          .footer-light-theme .footer-column .footer-list-link {
            display: block; /* Makes each link take its own line */
            margin-bottom: 0.6rem;
          }

          .footer-logo-img {
            max-width: 100%;
            height: auto;
            max-height: 60px; /* Control logo height */
            margin-bottom: 1rem; /* In case content stacks below it */
          }
          
          /* Responsive: Remove bottom margin from columns when they are side-by-side */
          @media (min-width: 768px) { /* Bootstrap md breakpoint */
            .footer-light-theme .footer-column {
              margin-bottom: 0;
            }
          }
        `}
      </style>
      <footer className="footer-light-theme">
        <div className="container">
          <div className="row">
            {/* Column 1: Logo */}
            <div className="col-lg-3 col-md-6 footer-column">
              <img
                src={logo} // Replace with your actual logo: companyLogo
                alt="Company Logo"
                className="footer-logo-img"
              />
              {/* You can add a short tagline under the logo if desired, though not in the image */}
            </div>

            {/* Column 2: Contact Us */}
            <div className="col-lg-3 col-md-6 footer-column">
              <h3>CONTACT US</h3>
              <p>
                Cardiff
                <br />
                Wales, CF3 2ER
                <br />
                United Kingdom
              </p>
              <p>
                <strong>Tel:</strong>{" "}
                <a href="tel:+44 029 2188 0665">+44 029 2188 0665</a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:Support@booze247.co.uk

"
                >
                  Support@booze247.co.uk
                </a>
              </p>
            </div>

            {/* Column 3: Hours */}
            <div className="col-lg-3 col-md-6 footer-column">
              <h3>Hours</h3>
              <p className="footer-list-item">24 Hours a Day</p>
              <p className="footer-list-item">7 Days A Week</p>
            </div>

            {/* Column 4: Discover More */}
            <div className="col-lg-3 col-md-6 footer-column">
              <h3>DISCOVER MORE</h3>
              <a
                href="https://www.facebook.com/boozedelivery247"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-list-link"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/booze_247?igsh=MTN6bnJxcW45enh3ZA%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-list-link"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
